/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function () {
  const profiles = window.OLT_VARIANT_PRODUCTION_PROFILES;

  // Garde-fou :
  // si le produit n'utilise pas production_profile, on ne touche pas à Zepto.
  if (!profiles || typeof profiles !== "object") return;

  const hasAnyProfile = Object.values(profiles).some(function (profile) {
    return profile && String(profile).trim() !== "";
  });

  if (!hasAnyProfile) return;

  function isCustomProfile(profile) {
    if (!profile) return false;

    profile = String(profile).trim().toUpperCase();

    return profile.indexOf("CUSTOM") === 0;
  }

  function toggleZeptoPersonalization() {
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );

    const zeptoBlock = document.querySelector(".product-personalizer");

    if (!variantInput || !zeptoBlock) return;

    const currentVariantId = variantInput.value;
    const currentProfile = profiles[currentVariantId];

    const shouldShowZepto = isCustomProfile(currentProfile);

    zeptoBlock.style.setProperty(
      "display",
      shouldShowZepto ? "block" : "none",
      "important"
    );
  }

  // Zepto peut se charger après la page
  setTimeout(toggleZeptoPersonalization, 100);
  setTimeout(toggleZeptoPersonalization, 500);
  setTimeout(toggleZeptoPersonalization, 1000);

  document.addEventListener("change", function () {
    setTimeout(toggleZeptoPersonalization, 50);
  });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
